import ConnectionStore from '@flux/stores/cxStore';
import envJson from '../../.env.json'

const app = {
  mode: envJson.NODE_ENV,
  cxStore: ConnectionStore,
};

export default app;
